<template>
  <div class="format-badge">
    <div class="account avatar" v-if="type === 'account'">
      <avatar :account="{avatar: avatar}" :alt="name || ''" :size="32" />
    </div>
    <template v-else>
      <div class="format" v-if="extension !== ''"
          :style="{'background-color': colorHelper.fromExtension(extension.toUpperCase())}">
        <span>{{extension.length > 4 ? extension.toUpperCase().substring(0, 3) + '…' : extension.toUpperCase()}}</span>
      </div>
      <template v-else>
        <div class="root-icon" v-if="icon !== '' && type === ''" role="img" :aria-label="iconLabel">
          <img
            v-if="icon === 'link'"
            src="/static/images/magic-link-dark.svg"
            alt=""
            aria-hidden="true"
          />
          <v-icon v-else aria-hidden="true">{{icon}}</v-icon>
        </div>
        <div class="icon" role="img" v-if="type !== '' && extension === ''" :aria-label="type" :style="{'background-color': colorHelper.fromType('', color)}">
          <v-icon class="white--text" aria-hidden="true">{{iconFromType}}</v-icon>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import colorHelper from '~/helpers/color'
  import {IconFromType} from '~/helpers/icon.js'

  export default {
    name: 'format-badge',
    props: {
      icon: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: ''
      },
      extension: {
        type: String,
        default: ''
      },
      avatar: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: null
      },
      name: String
    },
    data () {
      return {
        colorHelper: colorHelper
      }
    },
    computed: {
      iconFromType () {
        return IconFromType(this.type)
      },
      iconLabel () {
        if (this.icon === 'link') {
          return 'Magic Link'
        }
        const labels = {
          person: this.$t('Patient'),
          folder: this.$t('Study')
        }
        return labels[this.icon] || this.icon
      }
    }
  }
</script>
<style type="scss">
  .menu__content .account.avatar {
    min-width: 0;
  }
</style>
<style type="scss" scoped>
  .icon, .root-icon, .format {
    display: flex;
    align-content: center;
    justify-content: center;
    color: white;
  }

  .icon, .root-icon {
    width: 32px;
    height: 32px;
    border-radius: 16px;
    color: inherit;
    align-items: center;
  }

  .format {
    height: 25px;
    border-radius: 2px;
    padding: 2px 4px;
  }

  .format span {
    line-height: 21px;
    display: block;
    margin: auto;
    padding: 0;
  }

  .avatar {
    border-radius: 50%;
    height: 32px;
    width: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/files/FormatBadge.vue